import { StringKey } from '../../../lang/index';

export enum DividendColumn {
  ACTIONS = 'actions',
  APPROVAL_DATE = 'approval-date',
  FREQUENCY = 'frequency',
  PAYOUT_DATE = 'payout-date',
  PAYOUT_NAME = 'payout-name',
  PERIOD = 'period',
  SHARE_CLASS = 'share-class',
  STATUS = 'status',
  TOTAL_PAYOUT = 'total-payout',
}

export const dividendColumnTranslationKey: Record<DividendColumn, StringKey> = {
  [DividendColumn.PAYOUT_NAME]: 'PAYOUT_NAME',
  [DividendColumn.SHARE_CLASS]: 'SHARE_CLASS',
  [DividendColumn.FREQUENCY]: 'FREQUENCY',
  [DividendColumn.PERIOD]: 'PERIOD',
  [DividendColumn.TOTAL_PAYOUT]: 'TOTAL_PAYOUT',
  [DividendColumn.APPROVAL_DATE]: 'APPROVAL_DATE',
  [DividendColumn.PAYOUT_DATE]: 'PAYOUT_DATE',
  [DividendColumn.STATUS]: 'STATUS',
  [DividendColumn.ACTIONS]: 'EMPTY',
};

export const dividendColumnOrderMap = Object.keys(dividendColumnTranslationKey) as DividendColumn[];
